module.exports = __webpack_public_path__ + "img/closed-box.08225e786283ad62886e5a57786182ee.jpg";